var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M331.781,108c-6.633,0-12-3.582-12-8V68c0-4.418,5.367-8,12-8s12,3.582,12,8v32 C343.781,104.418,338.414,108,331.781,108z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M179.781,108c-6.633,0-12-3.582-12-8V68c0-4.418,5.367-8,12-8s12,3.582,12,8v32 C191.781,104.418,186.414,108,179.781,108z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#996459"
    },
    d: "M488,300H24c-4.422,0-8,3.582-8,8v136c0,22.055,17.945,40,40,40h400c22.055,0,40-17.945,40-40V308 C496,303.582,492.422,300,488,300z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA7958"
    },
    d: "M472,100H40c-22.055,0-40,17.945-40,40v139.207c0,16.086,9.664,30.598,24.625,36.973 C90.477,344.234,160.141,359.953,232,362.91h48c0.109,0,0.219-0.004,0.328-0.008c71.531-2.949,141.195-18.668,207.055-46.723 C502.336,309.805,512,295.293,512,279.207V140C512,117.945,494.055,100,472,100z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E5C62"
    },
    d: "M352,276c0-17.645-14.352-32-32-32H192c-17.648,0-32,14.355-32,32v79.435 c23.716,3.897,47.72,6.477,72,7.476h48c0.109,0,0.219-0.004,0.328-0.008c24.136-0.995,48.036-3.568,71.672-7.455V276z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD00"
    },
    d: "M264,388h-16c-8.837,0-16-7.163-16-16v-32c0-8.837,7.163-16,16-16h16c8.837,0,16,7.163,16,16v32 C280,380.836,272.837,388,264,388z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#996459"
    },
    d: "M344.008,71.746c-1.531,0-3.082-0.219-4.621-0.684C315.352,63.824,286.516,60,256,60 s-59.352,3.824-83.387,11.062c-8.465,2.563-17.383-2.25-19.934-10.707c-2.547-8.461,2.246-17.387,10.707-19.934 C190.375,32.297,222.403,28,256,28s65.625,4.297,92.613,12.422c8.461,2.547,13.254,11.473,10.707,19.934 C357.235,67.277,350.883,71.746,344.008,71.746z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE671"
    },
    d: "M271.781,324h-32c-4.418,0-8,3.582-8,8v16c0,8.837,7.163,16,16,16h16c8.837,0,16-7.163,16-16v-16 C279.781,327.582,276.199,324,271.781,324z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.1b893a7dab069633d346848d475fcffa.svg";
export { ForwardRef as ReactComponent };